// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21YmM","content":"styles_content__1BfH0"};